import { useParams } from "react-router";

export function useIsNewRoute() {
    const params = useParams<{ id?: string }>();
    return params.id === "new";
}
